import type {
  CallToolInput,
  CallToolResult,
  CreateMcpConnectionInput,
  McpConnectionDetail,
  McpConnectionListItem,
  McpPermissionRow,
  TestMcpResult,
  UpdateMcpConnectionInput,
  UpdateMcpPermissionsInput,
} from '@qualibot/shared';
import { api } from './api-client';

export async function listMcpConnections(): Promise<McpConnectionListItem[]> {
  const { data } = await api.get<{ items: McpConnectionListItem[] }>('/api/mcp-connections');
  return data.items;
}

export async function fetchMcpConnection(id: string): Promise<McpConnectionDetail> {
  const { data } = await api.get<McpConnectionDetail>(`/api/mcp-connections/${id}`);
  return data;
}

export async function createMcpConnection(
  input: CreateMcpConnectionInput,
): Promise<McpConnectionDetail> {
  const { data } = await api.post<McpConnectionDetail>('/api/mcp-connections', input);
  return data;
}

export async function updateMcpConnection(
  id: string,
  input: UpdateMcpConnectionInput,
): Promise<McpConnectionDetail> {
  const { data } = await api.put<McpConnectionDetail>(`/api/mcp-connections/${id}`, input);
  return data;
}

export async function deleteMcpConnection(id: string): Promise<void> {
  await api.delete(`/api/mcp-connections/${id}`);
}

export async function testMcpConnection(id: string): Promise<TestMcpResult> {
  const { data } = await api.post<TestMcpResult>(`/api/mcp-connections/${id}/test`);
  return data;
}

export async function fetchMcpPermissions(id: string): Promise<McpPermissionRow[]> {
  const { data } = await api.get<{ rows: McpPermissionRow[] }>(
    `/api/mcp-connections/${id}/permissions`,
  );
  return data.rows;
}

export async function applyMcpPermissions(
  id: string,
  input: UpdateMcpPermissionsInput,
): Promise<McpPermissionRow[]> {
  const { data } = await api.put<{ rows: McpPermissionRow[] }>(
    `/api/mcp-connections/${id}/permissions`,
    input,
  );
  return data.rows;
}

export async function callMcpTool(
  mcpId: string,
  toolId: string,
  input: CallToolInput,
): Promise<CallToolResult> {
  const { data } = await api.post<CallToolResult>(
    `/api/mcp-connections/${mcpId}/tools/${toolId}/call`,
    input,
  );
  return data;
}
